import script from "./MallShipmentLedger.vue?vue&type=script&setup=true&lang=ts"
export * from "./MallShipmentLedger.vue?vue&type=script&setup=true&lang=ts"

import "./MallShipmentLedger.scss?vue&type=style&index=0&lang=scss&external"

const __exports__ = script;

export default __exports__